
import { computed } from "@vue/reactivity";
import { ref } from "vue";
import router from "../router"; // <---

// ✅ MOVE THIS FUNCTION OUTSIDE setup() - at the top level
function getTenantHeader() {
    const tenantId = window.location.hostname.split('.')[0].toUpperCase();
    return { 'X-Tenant-ID': tenantId };
}

function getTenantId() {
    const tenantId = window.location.hostname.split('.')[0].toUpperCase();
    return tenantId;
}

export default {
  props: ["baseUrl"],
  setup(props: any) {
    const userName = ref("");
    const password = ref("");
    const loginResult = ref("");
    const baseUrlAddress = computed(() => {
      return `${props.baseUrl}`;
    });
    const registrationUrl = "/#/register";

    console.log("registrationUrl : ", registrationUrl);

    const login = () => {
      
      loginResult.value="";
      var requestUrl = baseUrlAddress.value + "Login/UserLoginForToken";

      
    const tenantId = window.location.hostname.split('.')[0].toUpperCase();
    //console.log("📢 Sending request with tenant header:", tenantId);
    //console.log("📢 API URL:", requestUrl);

      //var requestUrl = "http://emergingsols2.somee.com/Login/UserLoginForToken";

      //console.log("requestUrl : ", requestUrl);
      console.log("getTenantHeader : ", getTenantHeader());
      alert("getTenantId000 : " + getTenantId());


      var requestOptions = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          // 'Authorization':`Bearer ${token }`
          ...getTenantHeader()  // ← Spread the header

        },
        body: JSON.stringify({
          UserId: 0,
          UserName: userName.value, //"Shouket", //
          Password: password.value, //"ALLAH1", //
        }),
      };

      /*
       var requestOptions = {
        method: "POST",
       headers: {
              "Content-Type": "application/json",
              "X-Tenant-ID": getTenantId()  // ← Call the function
            },
          body: JSON.stringify({
              UserId: 0,
              UserName: userName.value, //"Shouket", //
              Password: password.value, //"ALLAH1", //
            }),
          };
*/

      fetch(requestUrl, requestOptions)
        .then((response) => // response.json()
        {
          let jsonResponse = null;
          console.log("value of response : ", response);
          if(response != null && response.ok== true )
          {
            jsonResponse = response.json();
          }
          else
            loginResult.value = "Could not login please try again.";
          return jsonResponse;
        }
        ).then((result) => {
          localStorage.setItem("Guardtoken","");
          //console.log("result", result.loginResultUserViewModel);
          if (result.loginResultUserViewModel?.token != null) {
            localStorage.setItem(
              "Guardtoken",
              result.loginResultUserViewModel?.token
              );
              
            //console.log("Guardtoken ", localStorage.getItem("Guardtoken"));

            localStorage.setItem(
              "OfficerId",
              result.loginResultUserViewModel?.officerId
            );

            // console.log("Guardtoken ", result.loginResultUserViewModel);

            localStorage.setItem("UserLoginId", result.loginResultUserViewModel?.id );
            localStorage.setItem("officerName", result.officerName);
            // router.push("schedule");
            router.push("jobcalls");
            router.push("profile");
          }
        })
        .then((Error) =>{
          //alert("Could not login please try again.");
          console.log("Error : " , Error);
          loginResult.value = "Error Occurred and could not login please try again.";
        });
    };

    

    return {
      userName,
      password,
      login,
      baseUrlAddress,
      loginResult,
      registrationUrl,
    };
  },
};
